// HOOKS
import { createContext, useEffect, useState } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import useQuery from "../../hooks/other/useQuery.other.hook";
// GRAPHQL
import { GET_USERS_QUERY } from "../../graphql/queries/users/users.jsx";

const DEFAULT_QUERY = {
  page: 1,
  limit: 25,
  sort: "name",
  search: "",
};

export const UsersContext = createContext({
  users: [],
  setUsers: () => {},
  fetchUsers: () => {},
  updateUsers: () => {},
  deleteUsers: () => {},
  createUser: () => {},
  isLoading: false,
  setIsLoading: () => {},
  query: {},
  userInput: {}, // Used for graphql query
  setUserInput: () => {},
  metaData: {},
  handleLimitChange: () => {},
  handlePageChange: () => {},
  handleSearch: () => {},
  handleSort: () => {},
});

export const UsersProvider = ({ children }) => {
  const {
    query,
    setQuery,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
  } = useQuery({ defaultQuery: DEFAULT_QUERY });
  // STATE

  const [users, setUsers] = useState([]);
  const [metaData, setMetaData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [userInput, setUserInput] = useState({}); // Used for graphql query
  // QUERIES
  const [getUsers] = useLazyQuery(GET_USERS_QUERY, {
    fetchPolicy: "no-cache",
  });
  // EFFECTS
  useEffect(() => {
    fetchUsers();
  }, [query, userInput]);
  useEffect(() => {
    fetchUsers();
  }, []);
  // METHODS
  // Fetches partOrders based on query and partOrderInput
  const fetchUsers = async () => {
    try {
      console.log("FETCHING USERS");
      setIsLoading(true);
      const { data } = await getUsers({
        variables: {
          query: query,
          user: userInput,
        },
      });
      setUsers(data.users.users);
      setMetaData(data.users.metaData);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const updateUsers = async () => {};
  const deleteUsers = async () => {};
  const createUser = async () => {};

  return (
    <UsersContext.Provider
      value={{
        users,
        setUsers,
        fetchUsers,
        updateUsers,
        deleteUsers,
        createUser,
        isLoading,
        setIsLoading,
        query,
        userInput,
        setUserInput,
        metaData,
        handleLimitChange,
        handlePageChange,
        handleSearch,
      }}
    >
      {children}
    </UsersContext.Provider>
  );
};
